import { BuzerIcon } from "../../../BuzerIcons";
import { DIFF_SK, DIFF_STARS, DIFFICULTIES, normDifficulty, pointsFor } from "../../../lib/points";
import { Caption } from "./Caption";
import { Pill } from "./Pill";

// v29 §1.2 — výber náročnosti do formulára návyku (nahrádza číselník „Body").
// Tri celoširoké možnosti postavené na <Pill> (vizuál on/off dedí z primitívu),
// každá ukazuje hviezdičky + slovenský názov + body za NASLEDUJÚCE splnenie.
//   value    — "easy" | "normal" | "hard"
//   onChange — (level) => void
//   streak   — aktuálna séria návyku (0 pri novom) — body sa počítajú pre sériu streak+1
//   size     — "md" (formulár) | "sm" (DETAIL výzvy: jeden riadok namiesto troch, bez hviezdičiek
//              a bez vysvetľujúcej vety — tá patrí do formulára, kde sa náročnosť volí prvýkrát;
//              v detaile zaberala tretinu obrazovky. Slovné názvy ostávajú, lebo bez nich by sa
//              náročnosť dala prečítať len z hviezdičiek.)
export function DifficultyPicker({ value, onChange, streak = 0, size = "md", className = "", ...rest }) {
  const cur = normDifficulty(value);
  const next = Math.max(0, Number(streak) || 0) + 1;
  const sm = size === "sm";
  return (
    <div className={`bz-diffpick${sm ? " bz-diffpick--sm" : ""} ${className}`.trim()} {...rest}>
      {DIFFICULTIES.map((d) => (
        <Pill key={d} on={cur === d} onClick={() => onChange && onChange(d)}
          aria-label={`Náročnosť: ${DIFF_SK[d]}, ${pointsFor(d, next)} bodov`}>
          {!sm && (
            <span className="bz-stars" aria-hidden="true">
              {Array.from({ length: DIFF_STARS[d] }).map((_, i) => (
                <BuzerIcon key={i} name="star" size={12} color="currentColor" />
              ))}
            </span>
          )}
          {DIFF_SK[d]}
          <span className="bz-diffpick__pts">{pointsFor(d, next)} b</span>
        </Pill>
      ))}
      {!sm && (
        <Caption variant="note">
          Body rastú so sériou — pri 30-dňovej sérii až {pointsFor(cur, 30)} b za splnenie.
        </Caption>
      )}
    </div>
  );
}
